import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'
import styled, { ThemeProvider } from 'styled-components'

export interface IChipContainerTheme {
  backgroundColor: string
  color: string
}

export const Container = styled.div<{ theme: IChipContainerTheme }>`
  white-space: nowrap;
  background-color: ${({ theme }): string => theme.backgroundColor || '#fff'};
  color: ${({ theme }): string => theme.color || '#000'};
  font-size: 14px;
  text-align: center;
  font-weight: 500;
  width: calc(100% - 8px);
  max-width: 100px;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
`

export const IsActive = ({ isActive }: { isActive: boolean }): ReactElement => {
  let theme: IChipContainerTheme

  if (isActive) {
    theme = { backgroundColor: '#00C875', color: '#fff' }
  } else {
    theme = { backgroundColor: '#B0B0B0', color: '#fff' }
  }

  return (
    <ThemeProvider theme={theme}>
      <Container>
        {isActive ? (
          <FormattedMessage id="dictionary.active" defaultMessage="Active" />
        ) : (
          <FormattedMessage id="dictionary.inactive" defaultMessage="Inactive" />
        )}
      </Container>
    </ThemeProvider>
  )
}

export const IsAssigned = ({ isAssigned }: { isAssigned: boolean }): ReactElement => {
  let theme: IChipContainerTheme
  if (isAssigned) {
    theme = { backgroundColor: '#645FFF', color: '#fff' }
  } else {
    theme = { backgroundColor: '#A86EEB', color: '#fff' }
  }

  return (
    <ThemeProvider theme={theme}>
      <Container>
        {isAssigned ? (
          <FormattedMessage id="dictionary.assigned" defaultMessage="Assigned" />
        ) : (
          <FormattedMessage id="dictionary.notAssigned" defaultMessage="Not Assigned" />
        )}
      </Container>
    </ThemeProvider>
  )
}
